import { render, staticRenderFns } from "./sample-account-icon-profile.vue?vue&type=template&id=4b097635&"
import script from "./sample-account-icon-profile.vue?vue&type=script&lang=js&"
export * from "./sample-account-icon-profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports